import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "box-login shadow" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "btn btn-primary" }
const _hoisted_8 = { class: "recover" }

import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { toast } from "@/common/utils/toast";
import { baseInput, svgIcon } from "@/common/components";

import { userRecover } from "@/common/api/rest/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

const email = ref<string>("");

const error = ref<{ [key: string]: string }>({});

function goTo(url: string) {
  router.push(url);
}

function goToValid() {
  router.push({
    path: "/auth/recover/valid",
    query: {
      hash: window.btoa(JSON.stringify({ email: email.value, code: null })),
    },
  });
}

function isValid() {
  error.value = {};

  if (!email.value.includes("@")) error.value.email = t("error.invalid");
  if (email.value.trim().length === 0) error.value.email = t("error.required");

  return Object.keys(error.value).length === 0;
}

function submit() {
  if (!isValid()) return;

  userRecover({
    email: email.value,
  })
    .then((response) => {
      const { success, message } = response;
      if (success) {
        toast({ message: message, type: "success" });
        goToValid();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/images/logo.png')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)("common.texts.recover_password").toUpperCase()), 1),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (submit()), ["prevent"]))
        }, [
          _createVNode(_unref(baseInput), {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            placeholder: _unref(t)('common.placeholders.email'),
            background: "#f1f1f1",
            maxLength: "50"
          }, _createSlots({
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.email")), 1)
            ]),
            _: 2
          }, [
            (error.value.email)
              ? {
                  name: "error",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.value.email), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "placeholder"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", _hoisted_7, _toDisplayString(_unref(t)("common.labels.send").toUpperCase()), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)("common.texts.remembered_password")), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-none font-bold",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (goTo('/auth/login')))
              }, _toDisplayString(_unref(t)("common.labels.login").toUpperCase()), 1)
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}
}

})